<template>
	<div :class="{ hidden: !showModal, 'main-modal': true }">
		<div class="main-modal-header">
			<div class="main-modal-right">
				<button @click="toggleComments">
					<b-icon icon="chevron-down"></b-icon>
				</button>
			</div>
		</div>
		<div class="main-modal-content">
			<b-modal ref="image-preview" id="image-preview">
				<img
					:src="downloadFileUrl(filePreviewCommentID, filePreview) || '#'"
					class="w-full"
					v-if="filePreview"
				/>
				<div slot="modal-footer">
					<a
						class="btn btn-primary"
						v-if="filePreview"
						:href="
							filePreview ? downloadFileUrl(filePreviewCommentID, filePreview) : '#'
						"
					>
						{{ $t("download") }}
					</a>
				</div>
			</b-modal>
			<div class="row">
				<div class="col-12 col-lg-8 mb-3" v-if="comments.length">
					<div class="list-group" data-cy="comments-list">
						<div
							v-for="(comment, index) in comments"
							v-bind:key="comment.CommentID"
							:class="getCommentClass(index)"
						>
							<div class="avatar float-left mr-4"></div>

							<div class="flex-1">
								<div class="float-right">
									<button class="btn" @click="deleteComment(comment.CommentID)">
										<b-icon icon="trash"></b-icon>
									</button>
								</div>

								<p class="mb-1 font-bold">
									<span class="mr-3">
										<b-icon icon="person-fill"></b-icon>
										{{ comment.displayName }}</span
									>
									<span>
										<b-icon icon="clock-fill"></b-icon>
										{{ formatDate(comment.DateCreated) }}
									</span>
								</p>

								<p class="mb-0">{{ comment.Comment }}</p>

								<div
									v-if="comment.DetailedFiles && comment.DetailedFiles.length"
									class="list-group"
								>
									{{ $t("attachments-colon") }}
									<div
										class="inline list-group-item mt-2"
										v-for="file in comment.DetailedFiles"
										v-bind:key="file.value"
									>
										<a
											href="#"
											class="image-preview mr-2"
											v-if="getFileIcon(file) === 'file-earmark-image'"
											@click="previewFile(comment.CommentID, file)"
										>
											<div class="image-preview-overlay">
												<b-icon icon="eye-fill"></b-icon>
											</div>
											<img
												:src="downloadFileUrl(comment.CommentID, file)"
												alt="#"
											/>
										</a>
										<a
											:href="downloadFileUrl(comment.CommentID, file)"
											target="_blank"
											class="btn btn-link"
										>
											<b-icon :icon="getFileIcon(file)"></b-icon>
											{{ $t("download-filename", { filename: file.name }) }}
										</a>
										<button
											class="btn float-right mt-2"
											@click="deleteFile(comment.CommentID, file)"
										>
											<b-icon icon="trash"></b-icon>
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="col-12 col-lg-4">

					<div class="well well-form mb-4">
						<h3 class="mb-4">{{ $t("add-comment") }}</h3>
						<label><b-icon icon="chat-dots"></b-icon>{{ $t("your-comment") }}</label>
						<b-form-textarea
							v-model="newComment"
							:placeholder="$t('enter-comment-ellipses')"
							data-cy="new-comment-input"
							rows="3"
							class="mb-4"
						></b-form-textarea>
						<label
							><b-icon icon="file-earmark-arrow-up"></b-icon>
							{{ $t("attachments") }}</label
						>
						<b-form-file
							multiple
							v-model="newFiles"
							:state="Boolean(newFiles)"
							:placeholder="$t('choose-file-or-drop-here-ellipses')"
							:drop-placeholder="$t('drop-file-here-ellipses')"
							:browse-text="$t('browse')"
							accept=".doc, .docx, .pdf, .xls, .xlsx, .csv, .jpg, .jpeg, .gif, .png"
							ref="comment-files"
							@input="uploadFiles"
							class="mb-4"
						></b-form-file>

						<div class="mb-3" v-if="newFiles && newFiles.length">
							{{ $t("files-uploading-colon") }}
							<div v-for="(newFile, fileIndex) in newFiles" v-bind:key="fileIndex">
								{{ $t("selected-file-colon") }} {{ newFile.name }}
							</div>
						</div>

						<div class="alert alert-danger" v-if="uploadError">
							{{ uploadError }}
						</div>

						<div v-if="DetailedFiles && DetailedFiles.length" class="list-group mb-4">
							{{ $t("attachments-colon") }}
							<div
								class="inline list-group-item mt-2"
								v-for="file in DetailedFiles"
								v-bind:key="file.value"
							>
								<b-icon :icon="getFileIcon(file)"></b-icon>
								{{ file.name }}

								<button class="btn float-right" @click="removeAttachment(file)">
									<b-icon icon="trash" class="mt-2"></b-icon>
								</button>
							</div>
						</div>

						<div class="form-check mb-3">
							<label class="form-check-label" for="important">
								<input type="checkbox" class="form-check-input" id="important" v-model="newCommentImportant">
									{{ $t('mark-as-important') }}
							</label>
						</div>

						<button
							class="btn btn-primary btn-block"
							@click="saveComment"
							:disabled="saving"
							data-cy="add-comment-button"
							v-if="!newFiles || !newFiles.length"
						>
							<b-icon icon="plus-circle"></b-icon>{{$t('add-comment')}}
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "treatmentsessioncomments",
	props: {
		treatmentsession: Object
	},
	data: function() {
		return {
			comments: [],
			initialCommentsLoaded: false,
			initialCommentsLength: 0,
			newComment: "",
			newCommentImportant: false,
			newFiles: [],
			FilesUploaded: [],
			DetailedFiles: [],
			uploadError: null,
			filePreview: null,
			filePreviewCommentID: null,
			saving: false
		};
	},
	mounted: function() {
		this.getCommentCount();
	},
	updated: function() {
		//console.log("newFiles updated", this.newFiles);
		//console.log("FilesUploaded updated", this.FilesUploaded);
	},
	beforeDestroy: function() {
		this.$store.state.treatmentSessionComments.showModal = false;
		this.$store.state.treatmentSessionComments.unreadCount = 0;
	},
	computed: {
		showModal() {
			if (this.$store.state.treatmentSessionComments.showModal) {
				this.getComments();
			}
			return this.$store.state.treatmentSessionComments.showModal;
		}
	},
	methods: {
		getCommentCount: function() {
			if (this.treatmentsession.id) {
				this.$cfetch
					.call(this, `${this.$settings.APIBaseURL}/treatmentsessions/countcomments`, {
						method: "post",
						data: {
							treatmentSession: this.treatmentsession.id
						}
					})
					.then(json => {
						if (json.count !== undefined) {
							this.$log.info.call(this, "Treatment session comments counted");
							/*this.$store.state.treatmentSessionComments.unreadCount =
								json.unreadCount;*/
							this.initialCommentsLength = json.unreadCount;
							if (this.showModal()) this.getComments();
						} else {
							this.$log.error.call(
								this,
								"Could not count treatment session comments"
							);
						}
					})
					.catch(error => {
						this.$log.error.call(this, error);
					});
			}
		},
		getComments: function() {
			if (this.treatmentsession.id) {
				this.$cfetch
					.call(this, `${this.$settings.APIBaseURL}/treatmentsessions/listcomments`, {
						method: "post",
						data: {
							treatmentSession: this.treatmentsession.id
						}
					})
					.then(json => {
						if (json.comments !== undefined) {
							this.$log.info.call(this, "Treatment session comments loaded");
							this.comments = json.comments.sort(
								(a, b) => b.DateCreated - a.DateCreated
							);

							if (!this.initialCommentsLoaded) {
								this.initialCommentsLength = json.comments.length;
								this.initialCommentsLoaded = true;
							}

							if (this.showModal) {
								this.$store.state.treatmentSessionComments.unreadCount = 0;
							}
						} else {
							this.$log.error.call(
								this,
								"Could not fetch treatment session comments"
							);
						}
					})
					.catch(error => {
						this.$log.error.call(this, error);
					});
			} else {
				// No treatmentsessionid defined. This is a new session.
			}
		},
		saveComment: function() {
			// a second tap while saving would post the comment (or create the session) twice
			if (this.saving) {
				return;
			}
			const hasContent = () => this.newComment.length || this.FilesUploaded.length;
			if (this.treatmentsession.id && !hasContent()) {
				return;
			}
			this.saving = true;

			let fallback = "something-went-wrong";
			let ready = Promise.resolve();
			if (!this.treatmentsession.id) {
				// No treatmentsessionid defined. This is a new session.
				fallback = "treatment-session-needs-saving-before-comments";
				this.$store.commit("showBlockingSpinner");
				this.treatmentsession.treatmentTimestamp = this.$datetime.getTimeStampFromDateTimeField(
					this.treatmentsession.datetime
				);
				ready = this.$cfetch(`${this.$settings.APIBaseURL}/treatmentsessions/save`, {
					method: "post",
					data: {
						treatmentsession: this.treatmentsession,
						markedByUser: this.markedByUser,
						markedByPassword: this.markedByPassword
					},
					retryIfOffline: false
				})
				.then(this.$assertApiSuccess)
				.then(json => {
					this.$store.commit("hideBlockingSpinner");
					this.treatmentsession.id = json.id;
				});
			}

			ready
				.then(() => {
					if (!hasContent()) {
						return;
					}
					fallback = "something-went-wrong";
					return this.$cfetch
						.call(this, `${this.$settings.APIBaseURL}/treatmentsessions/savecomment`, {
							method: "post",
							data: {
								treatmentSession: this.treatmentsession.id,
								comment: JSON.stringify({
									CommentParentID: this.$UserSession.getValue.call(this, "id"),
									CommentChildID: this.$UserSession.getValue.call(this, "id"),
									TreatmentSessionID: this.treatmentsession.id,
									FilesUploaded:
										this.FilesUploaded && this.FilesUploaded.length
											? JSON.stringify(this.FilesUploaded)
											: null,
									AuthorID: this.$UserSession.getValue.call(this, "id"),
									Comment: this.newComment,
									important: this.newCommentImportant,
									Shared: -1,
									LikeComment: -1,
									AlertComment: -1,
									PublishedState: 1
								})
							}
						})
						.then(this.$assertApiSuccess)
						.then(() => {
							this.$log.info.call(this, "Treatment session comment saved");
							this.getComments();
							this.newComment = "";
							this.newCommentImportant = false;
							this.FilesUploaded = [];
							this.DetailedFiles = [];
						});
				})
				.catch(err => {
					this.$store.commit("hideBlockingSpinner");
					this.$showApiError(err, { fallback });
				})
				.finally(() => {
					this.saving = false;
				});
		},
		deleteComment: function(commentID) {
			if (confirm("Delete comment?")) {
				if (this.treatmentsession.id && commentID) {
					this.$cfetch
						.call(
							this,
							`${this.$settings.APIBaseURL}/treatmentsessions/deletecomment`,
							{
								method: "post",
								data: {
									id: commentID
								}
							}
						)
						.then(json => {
							if (json.status === "SUCCESS") {
								this.$log.info.call(this, "Treatment session comment deleted");
								this.getComments();
							} else {
								this.$log.error.call(
									this,
									"Could not delete treatment session comment"
								);
							}
						})
						.catch(error => {
							this.$log.error.call(this, error);
						});
				} else {
					// No treatmentsessionid defined. This is a new session.
				}
			}
		},
		getFileIcon: function(file) {
			const map = {
				doc: "file-earmark-text",
				docx: "file-earmark-text",
				pdf: "file-earmark-text",
				xls: "file-earmark-spreadsheet",
				xlsx: "file-earmark-spreadsheet",
				csv: "file-earmark-spreadsheet",
				jpg: "file-earmark-image",
				jpeg: "file-earmark-image",
				gif: "file-earmark-image",
				png: "file-earmark-image"
			};
			return map[file.ext.toLowerCase()] !== undefined
				? map[file.ext.toLowerCase()]
				: "file-earmark";
		},
		uploadFiles: function() {
			if (this.newFiles && this.newFiles.length) {
				this.uploadError = null;

				let self = this;

				let data = new FormData();
				data.append("username", this.$UserSession.getValue.call(this, "username"));
				data.append("authToken", this.$UserSession.getValue.call(this, "authToken"));

				this.newFiles.forEach(function(item, index) {
					data.append("files[" + index + "]", item);
				});

				fetch(`${this.$settings.APIBaseURL}/treatmentsessions/uploadfile`, {
					method: "post",
					body: data
				})
					.then(result => {
						this.$log.info.call(this, result);
						if (result.status === 200) {
							result.json().then(json => {
								this.$log.info.call(this, JSON.stringify(json));
								if (json.status === "SUCCESS") {
									self.$log.info.call(this, "File uploaded");

									json.result.forEach(function(item/*, index*/) {
										self.FilesUploaded.push({
											asset_id: item.asset_id
										});
										self.DetailedFiles.push({
											name: item.asset_title,
											ext: item.asset_extension,
											value: item.asset_id
										});
									});
								} else {
									this.$log.error.call(this, "Could not upload file(s)");
									this.uploadError = this.$t("could-not-upload-files");
								}
							});
						} else {
							this.$log.error.call(this, "Could not upload file(s)");
							this.uploadError = this.$t("could-not-upload-files");
						}
						this.newFiles = [];
					})
					.catch(error => {
						this.$log.error.call(this, error);
						this.newFiles = [];
						this.uploadError = this.$t("could-not-upload-files");
					});
			}
		},
		downloadFileUrl: function(commentID, file) {
			let param = file.type === "file" ? "file" : "asset_id";
			let value = file.value;

			if (file.type === "file") {
				let split = value.split("/");
				if (split.indexOf("imagedb") !== -1) split.splice(0, split.indexOf("imagedb") + 1);
				value = "/" + split.join("/");
			}

			return (
				`${this.$settings.APIBaseURL}/treatmentsessions/downloadfile` +
				"?" +
				"username=" +
				this.$UserSession.getValue.call(this, "username") +
				"&authToken=" +
				this.$UserSession.getValue.call(this, "authToken") +
				"&comment_id=" +
				commentID +
				"&" +
				param +
				"=" +
				value
			);
		},
		deleteFile: function(commentID, file) {
			if (confirm("Delete file?")) {
				if (this.treatmentsession.id) {
					let param = file.type === "file" ? "filename" : "asset_id";
					let data = {
						id: commentID
					};
					data[param] = file.value;

					this.$cfetch
						.call(this, `${this.$settings.APIBaseURL}/treatmentsessions/deleteupload`, {
							method: "post",
							data: data
						})
						.then(json => {
							if (json.status === "SUCCESS") {
								this.$log.info.call(this, "File deleted");
								this.getComments();
							} else {
								this.$log.error.call(this, "Could not delete file");
							}
						})
						.catch(error => {
							this.$log.error.call(this, error);
						});
				} else {
					// No treatmentsessionid defined. This is a new session.
				}
			}
		},
		removeAttachment: function(file) {
			let self = this;
			this.DetailedFiles.forEach(function(item, fileIndex) {
				if (item.value == file.value) {
					self.DetailedFiles.splice(fileIndex, 1);
				}
			});

			this.FilesUploaded.forEach(function(file, fileIndex) {
				if (file.asset_id == file.value) {
					self.FilesUploaded.splice(fileIndex, 1);
				}
			});
		},
		toggleComments: function() {
			this.$store.state.treatmentSessionComments.showModal = !this.$store.state
				.treatmentSessionComments.showModal;
			if (this.showModal) {
				this.$store.state.treatmentSessionComments.unreadCount = 0;
			}
		},
		formatDate: function(ts) {
			// This function computes the delta between the
			// provided timestamp and the current time, then test
			// the delta for predefined ranges.

			var d = new Date(); // Gets the current time
			var nowTs = Math.floor(d.getTime() / 1000); // getTime() returns milliseconds, and we need seconds, hence the Math.floor and division by 1000
			var seconds = nowTs - ts;

			// more than three days
			if (seconds > 3 * 24 * 3600) {
				var tsd = new Date(ts * 1000);
				var dd = tsd.getDate();
				if (dd < 10) dd = "0" + dd;
				var mm = tsd.getMonth() + 1;
				if (mm < 10) mm = "0" + mm;
				return dd + "/" + mm + "/" + tsd.getFullYear();
			}

			// more than two days
			if (seconds > 2 * 24 * 3600) {
				return this.$t("a-few-days-ago");
			}
			// a day
			if (seconds > 24 * 3600) {
				return this.$t("yesterday");
			}

			if (seconds > 3600) {
				return this.$t("a-few-hours-ago");
			}
			if (seconds > 1800) {
				return this.$t("half-an-hour-ago");
			}
			if (seconds > 60) {
				return this.$tc("n-minutes-ago", Math.floor(seconds / 60));
			}
			return this.$t("less-than-1-minute-ago");
		},
		getCommentClass(index) {
			if (index === 0 && this.comments.length > this.initialCommentsLength) {
				return "list-group-item list-group-item-action flex flex-row items-center new-comment";
			}

			return "list-group-item list-group-item-action flex flex-row items-center";
		},
		previewFile(commentID, file) {
			this.filePreviewCommentID = commentID;
			this.filePreview = file;
			this.$refs["image-preview"].show();
		}
	}
};
</script>
